export const formatToMb = (mb) => mb / 1024 / 1024
